import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "emailField",
    "domainSearchField",
    "emailVerifierField",
    "teamSizeContainer",
    "emailAccountsField",
    "minimumQuotasAlert",
    "maximumQuotasAlert",
    "submitButton",
  ]

  static values = { minSearches: Number, minVerifications: Number }

  toggleTeamSize() {
    $(this.teamSizeContainerTarget).toggleClass("d-none")
  }

  toggleRequestType(e) {
    let selectedRequestType = document.getElementById(e.target.getAttribute("aria-controls"))
    selectedRequestType.classList.toggle("d-none")
  }

  validateQuotas() {
    if (
      this.domainSearchFieldTarget.value < this.minSearchesValue &&
      this.emailVerifierFieldTarget.value < this.minVerificationsValue
    ) {
      this.minimumQuotasAlertTarget.classList.remove("d-none")

      if (this.hasSubmitButtonTarget) {
        this.submitButtonTarget.setAttribute("disabled", "true")
      }

      return
    }

    this.minimumQuotasAlertTarget.classList.add("d-none")

    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.removeAttribute("disabled")
    }
  }

  validateForm(e) {
    e.preventDefault()

    if (
      this.domainSearchFieldTarget.value === "" &&
      this.emailVerifierFieldTarget.value === "" &&
      this.emailAccountsFieldTarget.value === ""
    ) {
      App.displayFlash("danger", i18n.t("js.front.enterprise_plan.please_provide_values"))
      setTimeout(function () {
        App.enableForm()
      }, 50)
      return
    }

    this.validateEmail(e)
  }

  validateEmail(e) {
    let domain = this.emailFieldTarget.value.split("@")[1]

    fetch(`https://velen.hunter.io/minimal-domain-info?domain=${domain}`, {
      credentials: "same-origin",
      headers: { Accept: "application/json" },
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.webmail || response.disposable) {
          App.displayFlash("danger", i18n.t("js.front.enterprise_plan.please_provide_professional_address"))
          App.enableForm()
          return
        }

        e.target.submit()
      })
  }
}
